import React from 'react'
import { Header, Home, About, Skills, Portfolio, Contact } from ".";
import ReactDOM from "react-dom";
export default class Client extends React.Component {
    constructor() {
        super();
        this.state = {
            homeNode: "",
            aboutNode: "",
            skillsNode: "",
            portfolioNode: "",
            contactNode: ""
        };
    }
    componentDidMount = () => {
        let homeNode = ReactDOM.findDOMNode(this.refs.home),
            aboutNode = ReactDOM.findDOMNode(this.refs.about),
            skillsNode = ReactDOM.findDOMNode(this.refs.skills),
            portfolioNode = ReactDOM.findDOMNode(this.refs.portfolio),
            contactNode = ReactDOM.findDOMNode(this.refs.contact);
        this.setState({ homeNode, aboutNode, skillsNode, portfolioNode, contactNode });
    }
    render() {
        return (
            <div>
                <Header refs={[this.state.homeNode, this.state.aboutNode, this.state.skillsNode, this.state.portfolioNode, this.state.contactNode]} />
                {/* <Home ref="home" /> */}
                <About ref="about" />
                <Skills ref="skills" />
                <Portfolio ref="portfolio" />
                <Contact ref="contact" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/client.jsx